// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"34":"airships","313":"submarines"}[chunkId] || chunkId) + "-legacy." + {"34":"9900b29a","313":"b1624b4c","906":"e52e9732"}[chunkId] + ".js";
};